<template>
  <CopyableText v-if="formatted && copyable" :secondary="secondary" :text="formatted" />
  <WdsText
    v-else
    :secondary="secondary || !formatted"
    :text="formatted ?? '—'"
    class="tw-whitespace-nowrap"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import CopyableText from '@/components/CopyableText.vue'
import { formatPhone } from '@/utils/phone'

const props = defineProps<{
  phone: string | null
  copyable?: boolean
  secondary?: boolean
}>()

const formatted = computed(() => (props.phone ? formatPhone(props.phone) : null))
</script>
